var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSilver(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        opacity: .23;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11, .cls-12, .cls-13, .cls-14, .cls-15, .cls-16, .cls-17, .cls-18, .cls-19, .cls-20, .cls-21, .cls-22, .cls-23, .cls-24, .cls-25, .cls-26, .cls-27, .cls-28 {\n        stroke-width: 0px;\n      }\n\n      .cls-1, .cls-29, .cls-30, .cls-31, .cls-3, .cls-4, .cls-15, .cls-16, .cls-17, .cls-18, .cls-27 {\n        mix-blend-mode: overlay;\n      }\n\n      .cls-1, .cls-3, .cls-4, .cls-6, .cls-15, .cls-17, .cls-18, .cls-27, .cls-28 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: #777c84;\n      }\n\n      .cls-29 {\n        opacity: .6;\n      }\n\n      .cls-30, .cls-18 {\n        opacity: .35;\n      }\n\n      .cls-31, .cls-4 {\n        opacity: .49;\n      }\n\n      .cls-32 {\n        mask: url(#mask);\n      }\n\n      .cls-3 {\n        opacity: .97;\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-33 {\n        filter: url(#luminosity-noclip);\n      }\n\n      .cls-6 {\n        opacity: .7;\n      }\n\n      .cls-7 {\n        fill: url(#radial-gradient);\n        mix-blend-mode: multiply;\n      }\n\n      .cls-8 {\n        fill: #828282;\n        opacity: .25;\n      }\n\n      .cls-9 {\n        fill: url(#linear-gradient-11);\n      }\n\n      .cls-10 {\n        fill: url(#linear-gradient-12);\n      }\n\n      .cls-11 {\n        fill: url(#linear-gradient-13);\n      }\n\n      .cls-12 {\n        fill: url(#linear-gradient-10);\n      }\n\n      .cls-13 {\n        fill: url(#linear-gradient-15);\n      }\n\n      .cls-14 {\n        fill: url(#linear-gradient-14);\n      }\n\n      .cls-15 {\n        opacity: .61;\n      }\n\n      .cls-16 {\n        fill: url(#radial-gradient-2);\n      }\n\n      .cls-17 {\n        opacity: .2;\n      }\n\n      .cls-19 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-20 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-21 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-22 {\n        fill: url(#linear-gradient-8);\n      }\n\n      .cls-23 {\n        fill: url(#linear-gradient-9);\n      }\n\n      .cls-24 {\n        fill: url(#linear-gradient-7);\n      }\n\n      .cls-25 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-26 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-34 {\n        isolation: isolate;\n      }\n\n      .cls-27 {\n        opacity: .41;\n      }\n\n      .cls-35 {\n        mask: url(#mask-1);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 325.13,
    y1: 327.23,
    x2: 325.13,
    y2: 635.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b5c0c9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f939c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -7716.95,
    y1: 327.23,
    x2: -7716.95,
    y2: 635.75,
    gradientTransform: "translate(-7038.38) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 501.08,
    y1: 108.61,
    x2: 501.08,
    y2: 372.21,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 573.5,
    y1: 295.62,
    x2: 627.57,
    y2: 390.39,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 502.56,
    y1: 312.4,
    x2: 667.19,
    y2: 312.4,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -3358.89,
    y1: 295.62,
    x2: -3304.82,
    y2: 390.39,
    gradientTransform: "translate(-2926.03) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 422.15,
    y1: 280.62,
    x2: 420.48,
    y2: 369.25,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 503.79,
    y1: 327.24,
    x2: 503.79,
    y2: 635.76,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 533.16,
    y1: 682.37,
    x2: 487.17,
    y2: 454.11,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip",
    x: 398.34,
    y: 306.29,
    width: 91.98,
    height: 85.66,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-2",
    x: 398.34,
    y: -8573,
    width: 91.98,
    height: 32766,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-1",
    x: 398.34,
    y: -8573,
    width: 91.98,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 444.33,
    cy: 349.12,
    fx: 444.33,
    fy: 349.12,
    r: 44.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#f6f6f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#ddd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#b5b5b5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#7e7e7e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#393939"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: 398.34,
    y: 306.29,
    width: 91.98,
    height: 85.66,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-33"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-35"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M444.34,306.29c-25.4,0-45.99,19.18-45.99,42.85s20.6,42.81,45.99,42.81,45.99-19.19,45.99-42.81-20.6-42.85-45.99-42.85Z"
  })))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 444.33,
    cy: 349.12,
    fx: 444.33,
    fy: 349.12,
    r: 44.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 546.83,
    y1: 703.19,
    x2: 581.92,
    y2: 764.69,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 500.8,
    y1: 714.08,
    x2: 607.64,
    y2: 714.08,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: -3381.59,
    y1: 703.19,
    x2: -3346.5,
    y2: 764.69,
    gradientTransform: "translate(-2926.03) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 448.61,
    y1: 693.45,
    x2: 447.52,
    y2: 750.98,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 501.08,
    y1: 327.24,
    x2: 501.08,
    y2: 635.76,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 507.03,
    y1: 771.96,
    x2: 498.44,
    y2: 729.3,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-34"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_5",
    "data-name": "Layer 5"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M445.86,751.95s-42.51,20.58-116.57-8.68c-74.06-29.26-97.61-67.89-97.61-67.89l39.43-22.97s-41.09-32.2-57.55-91.63c-16.45-59.43-14.57-66.95-14.57-66.95h36.57s-10.97-12.66,9.15-77.57c20.12-64.92,39.31-77.65,39.31-77.65l27.43,28.38s11.88-29.24,42.06-54.84c30.17-25.6,61.26-36.56,61.26-36.56l36.55,52.22-5.47,424.15Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-29"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M220.25,571.14c-16.46-59.43-14.57-66.62-14.57-66.62h36.57s-10.97-12.99,9.15-77.9c20.12-64.92,39.31-77.81,39.31-77.81l27.43,28.3s11.88-29.28,42.06-54.88c26.12-22.16,52.9-33.36,59.64-35.97l-5.07-10.65s-31.09,10.97-61.26,36.57c-30.18,25.6-42.06,54.85-42.06,54.85l-27.43-28.35s-19.2,12.67-39.31,77.59c-20.12,64.92-9.15,77.57-9.15,77.57h-36.57s-1.88,7.51,14.57,66.95c6.84,24.68,17.92,44.8,28.55,59.71-8.39-13.45-16.45-29.83-21.86-49.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M283.13,651.25s-1.03-1.61-14.62,2.67l-36.83,21.45s2.24,3.66,7.48,9.57l43.97-33.7Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M451.32,327.81l-36.55-52.22s-31.09,10.97-61.26,36.57c-30.18,25.6-42.06,54.86-42.06,54.86l-27.43-28.35s-19.2,12.67-39.31,77.59c-20.12,64.91-9.15,77.57-9.15,77.57h-36.57s-1.88,7.51,14.57,66.95c16.46,59.43,57.55,91.57,57.55,91.57l-39.43,23s7.79,12.75,28.41,29.13c18.58,4.23,37.91,6.47,57.76,6.47,46.11,0,89.4-12.04,126.92-33.13l6.56-350.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M443.38,583.49l7.94-255.68-36.55-52.22s-31.09,10.97-61.26,36.57c-30.18,25.6-42.06,54.86-42.06,54.86l-27.43-28.35s-19.2,12.67-39.31,77.59c-20.12,64.91-9.15,77.57-9.15,77.57h-36.57s-1.88,7.51,14.57,66.95c.78,2.83,1.64,5.63,2.53,8.33,34.04,27,77.1,43.17,123.93,43.17,37.84,0,73.21-10.5,103.36-28.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M442,489.54l9.32-161.73-36.55-52.22s-31.09,10.97-61.26,36.57c-30.18,25.6-42.06,54.86-42.06,54.86l-27.43-28.35s-18.66,12.46-38.46,75c24.62,51.63,77.28,87.3,138.29,87.3,20.58,0,40.21-4.07,58.14-11.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M331.85,334.4c14.81,30.5,46.08,51.52,82.27,51.52,9.14,0,17.96-1.36,26.29-3.86l10.91-54.25-36.55-52.22s-31.09,10.97-61.26,36.57c-8.69,7.37-15.85,15.04-21.66,22.24Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-31"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M235.56,487.42s-2.32-2.72-2.87-11.99c-.25,5.11-.05,7.72.33,11.99h2.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M329.28,734.91c-56.57-22.35-83.65-50.15-93.29-62.04l-4.31,2.52s23.55,38.63,97.61,67.89c74.06,29.26,116.57,8.68,116.57,8.68l-.12-8.3c-2.52,1.16-44.67,19.61-116.45-8.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M270.86,652.41l12.26-1.99s-53.23-38.57-69.69-98c-9.12-32.96-12.48-50.04-13.78-58.59h-.67s-2.01,7.51,14.45,66.95c12.68,45.79,42.1,79.33,57.43,91.63Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M555.11,751.95s42.51,20.58,116.57-8.68c74.06-29.26,97.6-67.89,97.6-67.89l-39.43-22.97s41.09-32.2,57.55-91.63c16.46-59.43,14.57-66.95,14.57-66.95h-36.57s10.97-12.66-9.15-77.57c-20.11-64.92-39.31-77.65-39.31-77.65l-27.43,28.38s-11.88-29.24-42.06-54.84c-30.17-25.6-61.26-36.56-61.26-36.56l-28.19,43.86-2.9,432.51Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-29"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M780.71,571.14c16.46-59.43,14.57-66.62,14.57-66.62h-36.57s10.97-12.99-9.15-77.9c-20.12-64.92-39.32-77.81-39.32-77.81l-27.43,28.3s-11.89-29.28-42.06-54.88c-26.12-22.16-52.9-33.36-59.64-35.97l5.07-10.65s31.09,10.97,61.26,36.57c30.17,25.6,42.06,54.85,42.06,54.85l27.43-28.35s19.2,12.67,39.31,77.59c20.12,64.92,9.15,77.57,9.15,77.57h36.57s1.88,7.51-14.57,66.95c-6.83,24.68-17.92,44.8-28.54,59.71,8.38-13.45,16.45-29.83,21.86-49.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M717.84,651.25s1.03-1.61,14.62,2.67l36.83,21.45s-2.24,3.66-7.48,9.57l-43.97-33.7Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M558.01,319.45l28.19-43.86s31.09,10.97,61.26,36.57c30.17,25.6,42.06,54.86,42.06,54.86l27.43-28.35s19.2,12.67,39.31,77.59c20.12,64.91,9.15,77.57,9.15,77.57h36.57s1.88,7.51-14.57,66.95c-16.46,59.43-57.55,91.57-57.55,91.57l39.43,23s-7.79,12.75-28.41,29.13c-18.57,4.23-37.91,6.47-57.76,6.47-46.11,0-89.4-12.04-126.92-33.13l1.81-358.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M557.59,583.49l.42-264.04,28.19-43.86s31.09,10.97,61.26,36.57c30.17,25.6,42.06,54.86,42.06,54.86l27.43-28.35s19.2,12.67,39.31,77.59c20.12,64.91,9.15,77.57,9.15,77.57h36.57s1.88,7.51-14.57,66.95c-.78,2.83-1.64,5.63-2.52,8.33-34.05,27-77.1,43.17-123.93,43.17-37.83,0-73.21-10.5-103.36-28.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M558.97,489.54l-.96-170.09,28.19-43.86s31.09,10.97,61.26,36.57c30.17,25.6,42.06,54.86,42.06,54.86l27.43-28.35s18.66,12.46,38.46,75c-24.62,51.63-77.28,87.3-138.29,87.3-20.58,0-40.21-4.07-58.14-11.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M669.11,334.4c-14.82,30.5-46.09,51.52-82.27,51.52-9.14,0-17.96-1.36-26.29-3.86l-2.55-62.62,28.19-43.86s31.09,10.97,61.26,36.57c8.69,7.37,15.85,15.04,21.66,22.24Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-31"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M765.4,487.42s2.32-2.72,2.87-11.99c.25,5.11.05,7.72-.34,11.99h-2.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M671.68,734.91c56.58-22.35,83.65-50.15,93.29-62.04l4.31,2.52s-23.54,38.63-97.6,67.89c-74.06,29.26-116.57,8.68-116.57,8.68l.13-8.3c2.52,1.16,44.67,19.61,116.45-8.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M730.1,652.41l-12.26-1.99s53.23-38.57,69.69-98c9.13-32.96,12.49-50.04,13.78-58.59h.67s2.01,7.51-14.45,66.95c-12.68,45.79-42.1,79.33-57.42,91.63Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "501.08 150.98 412.81 275.79 501.08 400.61 589.35 275.79 501.08 150.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "501.08 162.84 585.15 281.72 589.35 275.79 501.08 150.98 412.81 275.79 417 281.72 501.08 162.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "502.41 399.82 590.12 275.79 502.41 151.76 502.41 399.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "503.38 302.74 501.71 151.88 501.08 150.98 415.53 271.95 496.2 220.57 503.38 302.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "501.08 153.35 495.78 249.89 501.64 302.74 503.38 249.56 501.08 153.35"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "667.19 260.3 502.56 370.83 637.16 350.47 667.19 260.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "667.19 260.3 502.56 370.83 572.35 253.97 667.19 260.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "667.19 260.3 572.93 254.01 637.33 349.93 667.19 260.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "600.16 298.65 572.93 254.01 667.19 260.3 502.56 370.83 600.16 298.65"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "339.18 260.3 503.8 370.83 369.21 350.47 339.18 260.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-24",
    points: "339.18 260.3 503.8 370.83 434.02 253.97 339.18 260.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "339.18 260.3 433.44 254.01 369.03 349.93 339.18 260.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "406.2 298.65 433.44 254.01 339.18 260.3 503.8 370.83 406.2 298.65"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M503.8,313.21c-127.08,0-230.08,100.15-230.08,223.68s103.01,223.71,230.08,223.71,230.08-100.17,230.08-223.71-103.02-223.68-230.08-223.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M502.69,750.58c-125.35,0-227.27-97.47-230.02-218.7-.04,1.67-.07,3.34-.07,5.02,0,123.55,103.01,223.71,230.09,223.71s230.08-100.17,230.08-223.71c0-1.68-.03-3.35-.06-5.02-2.75,121.23-104.68,218.7-230.01,218.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M503.8,313.21c-127.08,0-230.08,100.15-230.08,223.68,0,2.73.12,5.4.23,8.11,58.61,51.1,139.29,82.7,228.36,82.7s172.59-32.73,231.42-85.42c.05-1.81.15-3.57.15-5.39,0-123.53-103.02-223.68-230.08-223.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M687.4,401.52c-42.02-53.64-108.4-88.31-183.12-88.31s-142.14,35.19-184.11,89.53c52.01,31.23,114.89,49.52,182.62,49.52s132.2-18.76,184.6-50.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M503.8,326.01c124.84,0,226.4,96.74,229.9,217.29.08-2.12.18-4.25.18-6.4,0-123.53-103.02-223.68-230.08-223.68s-230.07,100.15-230.07,223.68c0,2.15.1,4.29.17,6.4,3.5-120.55,105.04-217.29,229.9-217.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M472.9,327.92c10.71-.82,21.75,3.25,16.4,7.91-5.36,4.65-41.57,25.54-57.36,12.63-15.82-12.93,28.37-19.58,40.96-20.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M348.42,384.79c-33.52,28.2-60.61,80.31-59.93,110.76.68,30.44,16.95-17.32,25.35-34.65,8.41-17.31,50.39-70.17,80.83-86.15,30.45-16.01,6.17-34.06-46.24,10.05Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M503.81,370.34c-94.48,0-171.08,74.48-171.08,166.33s76.59,166.33,171.08,166.33,171.06-74.47,171.06-166.33-76.57-166.33-171.06-166.33Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-30"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M503.53,714.08c-99.61,0-180.64-78.89-180.64-175.86s81.03-175.86,180.64-175.86,180.63,78.89,180.63,175.86-81.03,175.86-180.63,175.86ZM503.53,378.32c-90.8,0-164.69,71.73-164.69,159.9s73.89,159.9,164.69,159.9,164.67-71.73,164.67-159.9-73.87-159.9-164.67-159.9Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M503.81,370.34c-50.17,0-95.3,21-126.59,54.48,30.53-27.59,71.43-44.47,116.41-44.47,94.46,0,171.05,74.45,171.05,166.32,0,43.09-16.84,82.35-44.48,111.89,33.64-30.38,54.67-73.73,54.67-121.89,0-91.85-76.57-166.33-171.06-166.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M397.26,635.06c0-107.34,76.59-166.32,171.06-166.32,38.61,0,74.21,12.43,102.82,33.4-16.34-75.28-85.05-131.79-167.36-131.79-94.47,0-171.05,74.48-171.05,166.33,0,54.36,26.8,102.6,68.24,132.96-2.4-11.15-3.71-22.71-3.71-34.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M503.81,693.92c-92.82,0-168.32-71.92-170.92-161.56-.07,1.59-.15,3.17-.15,4.78,0,91.88,76.59,166.33,171.08,166.33s171.06-74.45,171.06-166.33c0-1.61-.07-3.19-.12-4.78-2.62,89.64-78.11,161.56-170.94,161.56Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-32"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M444.34,306.29c-25.4,0-45.99,19.18-45.99,42.85s20.6,42.81,45.99,42.81,45.99-19.19,45.99-42.81-20.6-42.85-45.99-42.85Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M402.33,405.5c12.34-13.85,48.64-56.36,48.64-56.36,0,0,30.31-56.89,31.05-58.49.2-.46-38.74,53.49-38.74,53.49l-40.94,61.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M454.34,338.95c-11.18-8.75-9.15-33.34-9.24-40.3v6.67c0-1.06-.08-2.21-.08-2.46v-4.2c-.01,2-.15,5.16-.62,8.81,0,0-3.28,24.68-9.19,29.78-13.32,11.69-46.85,9.43-33.99,9.73,43.42.93,43.42,43.31,43.8,57.21v-7c.04.5.08.92.08,1.17v5.83c.92-32.91.81-53.73,38.69-56.51,12.54-.96-16.37,1.45-29.45-8.73Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "607.64 680.27 500.8 752 588.15 738.79 607.64 680.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "607.64 680.27 500.8 752 546.09 676.16 607.64 680.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "607.64 680.27 546.46 676.18 588.26 738.43 607.64 680.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "564.14 705.16 546.46 676.18 607.64 680.27 500.8 752 564.14 705.16"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "394.76 680.27 501.6 752 414.25 738.79 394.76 680.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "394.76 680.27 501.6 752 456.31 676.16 394.76 680.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "394.76 680.27 455.93 676.18 414.13 738.43 394.76 680.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "438.26 705.16 455.93 676.18 394.76 680.27 501.6 752 438.26 705.16"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "501.08 690.88 412.81 745.58 501.08 800.28 589.35 745.58 501.08 690.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "501.08 696.08 585.15 748.18 589.35 745.58 501.08 690.88 412.81 745.58 417 748.18 501.08 696.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "502.41 799.93 590.12 745.58 502.41 691.22 502.41 799.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "501.13 799.16 499.47 733.05 501.08 690.88 415.53 743.89 472.09 758.98 501.13 799.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "501.08 691.92 412.81 745.58 501.08 742.11 589.35 745.58 501.08 691.92"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M501.55,713.65c-17.66,0-31.97,13.92-31.97,31.08s14.32,31.09,31.97,31.09,31.97-13.92,31.97-31.09-14.31-31.08-31.97-31.08Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-30"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M501.5,777.89c-18.61,0-33.76-14.74-33.76-32.87s15.15-32.87,33.76-32.87,33.76,14.74,33.76,32.87-15.14,32.87-33.76,32.87ZM501.5,715.14c-16.97,0-30.78,13.4-30.78,29.88s13.81,29.88,30.78,29.88,30.78-13.4,30.78-29.88-13.8-29.88-30.78-29.88Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M501.55,713.65c-9.38,0-17.81,3.92-23.66,10.18,5.71-5.15,13.35-8.31,21.76-8.31,17.65,0,31.97,13.91,31.97,31.08,0,8.05-3.15,15.39-8.31,20.91,6.29-5.68,10.21-13.78,10.21-22.78,0-17.16-14.31-31.08-31.97-31.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M481.63,763.12c0-20.06,14.32-31.08,31.97-31.08,7.22,0,13.87,2.32,19.21,6.24-3.06-14.07-15.89-24.63-31.27-24.63-17.65,0-31.97,13.92-31.97,31.08,0,10.16,5.01,19.18,12.75,24.85-.45-2.08-.7-4.24-.7-6.46Z"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSilver);
export default __webpack_public_path__ + "static/media/silver.faa7ac71d1a142be453972d5bd3f32e2.svg";
export { ForwardRef as ReactComponent };